import React, {Component} from 'react';
import {moment, $} from '../ext-refs';
import {FieldWrapper, StateWrapper} from "../form-validator";
import PropTypes from 'prop-types';
import classNames from "classnames";

/**
 * React wrapper for date field
 * @see https://mdbootstrap.com/javascript/date-picker/
 */
class DateField extends Component {
    constructor(props) {
        super(props);
        this.onSet = this.onSet.bind(this);
    }

    onSet(context) {
        const hasClickedClear = Object.keys(context).includes('clear'),
            {name, setValue, postProcess} = this.props;

        // if a value is selected, parse its value. When clicking 'clear' on the widget, selected value will be null
        let fValue = hasClickedClear ? null : moment(context.select).format('MMDDYYYY');
        setValue(name, fValue, postProcess);
    }

    componentDidMount() {
        const $s = $(this.node),
            {min, max, format, hideClearButton} = this.props,
            date = this.props.value ? moment(this.props.value, 'MMDDYYYY').valueOf() : null;
        $s.pickadate({
            format: format || 'mmm dd, yyyy',
            min: min ? parseInt(min) : undefined,	// don't know what min past date will be, set to 15 for now
            max: max ? max : undefined, // if agent is allowed to pick today's date, set this to true. For now the max date is previous day.
            editable: false, // if editable is set to true, events have to be manually bound
            onSet: this.onSet,
            clear: hideClearButton ? '' : undefined // If clear is set to '', the clear button will hide.
        });
        //Set the initialized value in the Date Picker
        $s.pickadate('picker').set('select', date, {muted: true});
        
    }

    /**
     * If the value of the date picker changes dynamically through state change, update the value of the pickadate 
     * component to reflect on the UI. We mute the onSet event so that it is not triggered a second time
     * @param prevProps
     */
    componentDidUpdate(prevProps) {
        const $s = $(this.node),
            pickadate = $s.pickadate('picker');

        if (this.props.value !== prevProps.value) {
            let date = this.props.value ? moment(this.props.value, 'MMDDYYYY').valueOf() : null;
            pickadate.set('select', date, {muted: true});
        }
    }

    render() {
        const {
                name, format, placeholder, description, className, labelClass,
                min, max, hideClearButton,
                // extract validations so it does not go into rest
                validations,
                // These values are injected by StateWrapper
                value, setValue, postProcess, onBlur, validationState,
                ...rest
            } = this.props,
            {status, messages} = validationState || {},
            hasError = status === 'error' && Array.isArray(messages);
        return (
            <div className={className || "md-form form-group"}>
                <input
                    name={name}
                    type="text"
                    className={classNames("form-control", "datepicker", {'is-invalid': hasError})}
                    id={name}
                    placeholder={placeholder}
                    onBlur={onBlur}
                    aria-describedby={"sr-" + name}
                    aria-invalid={hasError}
                    ref={node => {
                        this.node = node
                    }}
                    {...rest}
                />
                {description &&
                    (<label htmlFor={name} className={classNames("active", labelClass)}>
                        {typeof description === 'function' ? description() : description}
                    </label>)
                }
                <div key={"sr-" + name} id={"sr-" + name} className={classNames("error-message", {'invalid-feedback': hasError})}
                     aria-live="assertive" aria-hidden={hasError ? 'false' : 'true'}>
                    {
                        hasError && messages.map(
                            item => (
                                <div key={item}>
                                    {item}
                                </div>
                            ))
                    }
                </div>
            </div>
        );
    }
}

DateField.propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func
    ]),
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    format: PropTypes.string,
    setValue: PropTypes.func.isRequired,
    postProcess: PropTypes.func,
    hideClearButton: PropTypes.bool
};

export {DateField as NoValidationDateField};
export default FieldWrapper(DateField);